import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../app/store';

// Agent state type (extracted from the agent namespace)
type AgentState = RootState['agent'];

// Typed hooks for agent state (now part of main store)
export const useAgentDispatch = () => useDispatch<AppDispatch>();
export const useAgentSelector = <T,>(selector: (state: AgentState) => T): T =>
  useSelector((state: RootState) => selector(state.agent));
